<template>
  <div style="margin-top: 5px" id="target" class="e-card">
    <div class="e-card-title">{{ gridTitle }}</div>
    <div class="e-card-separator"></div>
    <div class="e-card-content">
      <ejs-grid
        ref="grid"
        :created="created"
        :dataSource="dataSource"
        :allowPaging="true"
        :allowSorting="true"
        :pageSettings="pageSettings"
        :allowResizing="true"
        :allowTextWrap="true"
        :toolbar="toolbarOptions"
        :queryCellInfo="customiseCell"
        :commandClick="commandClick"
      >
        <e-columns>
          <e-column
            headerText="Documents"
            width="120"
            textAlign="Left"
            :commands="commands" />

          <e-column
            field="applicationType"
            headerText="Application Type"
            width="200"
            textAlign="Left"
          />
          <e-column field="permitNo" headerText="Permit #/Year" textAlign="Left" width="150"/>
          <e-column
            field="issueDate"
            headerText="Permit Issue Date"
            textAlign="Left"
            type="date"
            format="MMM dd,yyyy"
          />
          <e-column
            field="expiryDate"
            headerText="Expiry Date"
            textAlign="Left"
            type="date"
            format="MMM dd,yyyy"
          />
          <e-column field="siteNo" headerText="Site #" textAlign="Left" width="100" />
          <e-column field="location" headerText="Location" textAlign="Left" width="400" />
        </e-columns>
      </ejs-grid>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  GridPlugin, Page, Toolbar, CommandColumn, Sort, Search,
} from '@syncfusion/ej2-vue-grids';
import { DialogUtility } from '@syncfusion/ej2-popups';
import { tokenStorage } from '@/shared/storage-service';
import { mapGetters } from 'vuex';
import { getPermitPDF, updateCertificate } from '../../search-requests/services/municipality-api';

Vue.use(GridPlugin);
let DialogObj;
export default {
  name: 'MyRecords',
  props: {
    dataSource: Array,
    gridTitle: String,
    isAdmin: {
      type: Boolean,
      default: false,
    },
    onQueryCell: { type: Function },
  },
  provide: {
    grid: [Page, Toolbar, Sort, Search, CommandColumn],
  },
  data() {
    return {
      pageSettings: { pageSize: 15 },
      toolbarOptions: ['Search'],
      commands: [
        {
          type: 'View PDF',
          buttonOption: {
            cssClass: 'e-flat viewpdfbtn',
            iconCss: 'e-export-pdf e-icons',
          },
        },
        {
          type: 'Update Certificate',
          buttonOption: {
            cssClass: 'e-flat gotobtn',
            iconCss: 'certificate-icon e-icons',
          },
        },
      ],
      documentId: null,
    };
  },
  computed: {
    ...mapGetters({
      loggedUser: 'loggedUser',
    }),
  },
  methods: {
    created() {
      // Added clear button and its functionalities to Searchbar
      if (this.$refs.grid) {
        document
          .getElementById(`${this.$refs.grid.$el.id}_searchbar`)
          .addEventListener('keyup', (e) => {
            const searchBtnEle = document.getElementById(`${this.$refs.grid.$el.id}_searchbutton`);
            const clearBtnEle = searchBtnEle.cloneNode(true);
            clearBtnEle.id = `${this.$refs.grid.$el.id}_clearbutton`;
            clearBtnEle.classList.remove('e-search-icon');
            clearBtnEle.classList.add('e-clear-icon');

            clearBtnEle.addEventListener('click', () => {
              e.target.value = '';
              document.getElementById(`${this.$refs.grid.$el.id}_clearbutton`).remove();
            });

            if (e.target.value && searchBtnEle.parentNode.childElementCount === 2) {
              searchBtnEle.parentNode.insertBefore(
                clearBtnEle,
                searchBtnEle.parentNode.children[1],
              );
            } else if (!e.target.value || e.target.value === '') {
              document.getElementById(`${this.$refs.grid.$el.id}_clearbutton`).remove();
            }
          });
      }
    },
    async commandClick(args) {
      const accessToken = tokenStorage.getAccessToken();
      const userId = this.loggedUser.id;
      this.documentId = args.rowData.documentId;
      // eslint-disable-next-line default-case
      switch (args.commandColumn.type) {
        case 'View PDF':
          if (this.documentId) {
            await getPermitPDF(userId, accessToken, this.documentId).then((res) => {
              window.location.href = `${res.config.baseURL}${res.config.url}`;
            });
          }
          break;
        case 'Update Certificate':
          if (this.isAdmin && this.documentId.includes('R')) {
            DialogObj = DialogUtility.confirm({
              title: 'Update Certificate',
              content: 'Are you sure you want to Update selected Certificate?',
              okButton: { text: 'OK', click: this.updteCertificate },
              cancelButton: { text: 'Cancel', click: this.hideDeleteDialog },
              showCloseIcon: true,
              closeOnEscape: true,
              animationSettings: { effect: 'Zoom' },
            });
          }
          break;
      }
    },
    async updteCertificate() {
      await updateCertificate(this.documentId).then(() => {
        this.notify("success", "Certification Updated.");
        this.hideDialog();
      })
        .catch(() => {
          this.notify("Error", "Certification Error.");
          this.hideDialog();
          // DialogUtility.alert(error.message);
        });
    },
    hideDialog() {
      DialogObj.hide();
    },
    customiseCell(args) {
      // passing it to the parent so the event can be handled according to the grid type (open/hist)
      this.onQueryCell(args);
    },
    notify(type, message) {
      this.$parent.$parent.$parent.notificationToasts.push({
        title: type,
        content: message,
        cssClass: type === 'Error' ? 'e-toast-danger' : 'e-toast-success',
        timeOut: 5000,
      });
      if (this.$parent.$parent.$parent.notificationToasts.length > 0) {
        this.$parent.$parent.$parent.$refs.notifierRef.show();
      }
    },
  },
};
</script>

<style>
@import "../../../assets/styles/eservices-base.css";

.e-card-content {
  margin: 0% !important;
}
.hidebtn {
  display: none;
}
.certificate-icon {
   background: url("../../../assets/certificate-icon.svg");
  background-repeat: no-repeat;
  background-size: 24px 24px;
  width: 24px !important;
  height: 24px;
}
.e-export-pdf {
  font-size: 18px !important;;
}
.e-grid .e-unboundcelldiv > button {
    margin: 0px !important;
}
</style>
